module.exports = __webpack_public_path__ + "img/tooth7.3286ee61.png";